"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DmsTableFooter = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntlUniversal = _interopRequireDefault(require("react-intl-universal"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * DmsTableFooter component displays pagination controls at the bottom of a table.
 * @param {Object} props - Component props.
 * @param {Object} props.pagination - Pagination object containing total items, current page, etc.
 * @param {Function} props.handlePageChange - Function to handle page change.
 * @param {Function} props.handlePageLengthChange - Function to handle change in number of items per page.
 * @returns {JSX.Element} Table footer with pagination controls.
 */
const DmsTableFooter = _ref => {
  let {
    pagination = {
      total: 0,
      limit: 10,
      page: 0
    },
    handlePageChange,
    handlePageLengthChange
  } = _ref;
  const count = typeof pagination.total === 'number' ? pagination.total : 0;
  const rowsPerPage = typeof pagination.limit === 'number' ? pagination.limit : 10;
  const page = typeof pagination.page === 'number' ? pagination.page : 0;
  return /*#__PURE__*/_react.default.createElement(_material.TableFooter, null, /*#__PURE__*/_react.default.createElement(_material.TableRow, null, /*#__PURE__*/_react.default.createElement(_material.TableCell, {
    colSpan: 1000,
    sx: {
      p: 1,
      textAlign: 'right'
    }
  }, /*#__PURE__*/_react.default.createElement(_material.TablePagination, {
    component: "div",
    count: count,
    rowsPerPage: rowsPerPage,
    page: page,
    onPageChange: handlePageChange,
    onRowsPerPageChange: handlePageLengthChange,
    labelRowsPerPage: _reactIntlUniversal.default.get("rowsperpage").d("Rows per page:"),
    showLastButton: true,
    showFirstButton: true,
    sx: {
      justifyContent: 'flex-end',
      '& .MuiTablePagination-toolbar': {
        justifyContent: 'flex-end',
        flexWrap: 'wrap'
      },
      '& .MuiTablePagination-spacer': {
        flexGrow: 1
      },
      '& .MuiTablePagination-actions': {
        display: 'flex',
        alignItems: 'center'
      },
      '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows': {
        margin: 0,
        lineHeight: 'inherit'
      },
      '& .MuiTablePagination-selectRoot': {
        margin: 0,
        display: 'flex',
        alignItems: 'center'
      }
    }
  }))));
};
exports.DmsTableFooter = DmsTableFooter;
DmsTableFooter.propTypes = {
  pagination: _propTypes.default.shape({
    total: _propTypes.default.number,
    limit: _propTypes.default.number,
    page: _propTypes.default.number
  }),
  handlePageChange: _propTypes.default.func.isRequired,
  handlePageLengthChange: _propTypes.default.func.isRequired
};